<template>
  <v-card width="100%" color="transparent" class="pt-10" flat>
    <!-- custom-img-pos -->
    <!-- <div class="footer-img"> -->
    <!-- max-height="200"
        position="bottom" -->
    <!-- position="bottom" -->
    <!-- </div> -->
    <!-- :img="require('@/assets/imgs/TheFooter/cloud.png')" -->
    <v-img
      src="@/assets/imgs/TheFooter/cloud-2.png"
      max-height="300"
      width="100%"
      position="center"
    />
    <v-card flat class="pb-16">
      <v-container class="text-center" fluid>
        <div class="text-body-2 text-sm-h6 font-weight-regular">
          Copy Right&copy;2021_Design Store All Rights Reserved
        </div>
        <div class="links my-6 d-flex align-center justify-center">
          <div class="box" v-for="n in 4" :key="n">
            <v-img
              :src="require(`@/assets/imgs/TheFooter/${n}.png`)"
              contain
              width="130"
              max-height="70"
            />
          </div>
        </div>
        <div
          class="social-links d-flex align-center flex-column justify-center"
        >
          <!-- flex-sm-row -->
          <div class="email d-flex align-center">
            <!-- email -->
            <a href="mailto:mohammedalsydy21@gmail.com">
              <span class="text-caption underline">info@Designstore.Ga</span>
            </a>
            <v-img
              class="d-inline-block mr-1"
              src="@/assets/imgs/TheHeader/mail.png"
              contain
              width="25"
              max-width="25"
              height="20"
            />
          </div>
          <!-- phone-numbers -->
          <div class="whatsapp mr-4 d-flex align-center">
            <div class="text-caption d-inline-block">
              <a
                href="https://api.whatsapp.com/send?phone=+201095944347"
                target="_blank"
              >
                <span class="underline">01095944347</span>
              </a>
              <span>- </span>
              <a
                href="https://api.whatsapp.com/send?phone=+2001154154931"
                target="_blank"
              >
                <span class="underline">01154154931</span>
              </a>
            </div>
            <v-img
              src="@/assets/imgs/TheHeader/whatsapp.png"
              class="d-inline-block mr-1"
              contain
              width="25"
              max-width="25"
            />
          </div>
        </div>
        <div class="facebook-page" style="width: max-content">
          <a
            style="width: max-content"
            target="_blank"
            href="https://www.facebook.com/designstoreofficialpage/"
          >
            <v-img
              class="pointer"
              src="@/assets/imgs/TheFooter/facebook.png"
              max-width="200"
            />
          </a>
        </div>
      </v-container>
    </v-card>
  </v-card>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.links {
  max-width: 450px;
  margin: 0 auto;
  .box {
    width: calc(100% / 4);
  }
}
.custom-img-pos {
  background-position-y: bottom !important;
}
.footer-img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 1;
}
</style>